import * as React from 'react'
import { forwardRef } from 'react'

import {
  SavedViews,
  SavedViewsRef,
} from '~/client/src/desktop/components/SavedViews'
import { LocalStorageKey } from '~/client/src/shared/enums/LocalStorageKey'
import { IFilters } from '~/client/src/shared/stores/InitialState'
import LogisticsFilterStore from '~/client/src/shared/stores/LogisticsFilter.store'

import { useWorkflowsSavedViews } from '../../../../hooks/useWorkflowsSavedViews'

interface WorkflowSavedViewsProps {
  logisticsFilterStore: LogisticsFilterStore
  filters: IFilters & any
  projectId: string
}

const WorkflowSavedViews = forwardRef<SavedViewsRef, WorkflowSavedViewsProps>(
  ({ logisticsFilterStore, filters, projectId }, ref) => {
    const savedViewsAdapter = useWorkflowsSavedViews({
      projectId,
      logisticsFilterStore,
      filters,
    })

    return (
      <SavedViews
        ref={ref}
        className="workflow-filter-tabs-container"
        views={savedViewsAdapter.savedViews}
        onViewSelect={savedViewsAdapter.handleApplyFilters}
        filterType="workflows"
        saveFilterMutation={savedViewsAdapter.saveFilterMutation}
        deleteFilterMutation={savedViewsAdapter.deleteFilterMutation}
        refetchQueryName="GetWorkflowCustomFiltersByProject"
        appliedFilters={savedViewsAdapter.appliedFilters}
        currentGrouping={savedViewsAdapter.currentGrouping}
        facets={savedViewsAdapter.facets}
        groupingOptions={savedViewsAdapter.groupingOptions}
        localStorageKey={LocalStorageKey.WorkflowSavedView}
      />
    )
  },
)

export default WorkflowSavedViews
